import { createApp } from 'vue'
import App from './App.vue'
import router from "./router/index.js";
import Vant from 'vant'
import 'vant/lib/index.css';
import store from "./store/index.js";
import './assets/css/reset.less';
import 'amfe-flexible'
// 引入Quill样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// 引入视口刷新控制器
import { viewportRefresh } from './util/viewportRefresh.js';

// 全局配置视口刷新参数
viewportRefresh.config = {
  ...viewportRefresh.config,
  widthChangeThreshold: 150,
  debounceDelay: 800,
  debug: process.env.NODE_ENV === 'development',
  // 自定义提示信息
  message: '检测到屏幕尺寸变化，页面正在更新布局，请稍候...',
  // 提示显示时间(ms)
  notificationDuration: 1000
};
const app = createApp(App);


app.use(router).use(Vant).use(store).mount('#app')